import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import voiceService from '../services/voiceService';

export const fetchCommands = createAsyncThunk(
  'voice/fetchCommands',
  async (_, { rejectWithValue }) => {
    try {
      const response = await voiceService.getCommands();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchExamples = createAsyncThunk(
  'voice/fetchExamples',
  async (_, { rejectWithValue }) => {
    try {
      const response = await voiceService.getCommandExamples();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const processCommand = createAsyncThunk(
  'voice/processCommand',
  async (text, { rejectWithValue }) => {
    try {
      const response = await voiceService.processCommand(text);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  commands: [],
  examples: {},
  loading: false,
  error: null,
};

const voiceSlice = createSlice({
  name: 'voice',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch commands
    builder
      .addCase(fetchCommands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommands.fulfilled, (state, action) => {
        state.loading = false;
        state.commands = action.payload;
      })
      .addCase(fetchCommands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch examples
    builder
      .addCase(fetchExamples.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExamples.fulfilled, (state, action) => {
        state.loading = false;
        state.examples = action.payload;
      })
      .addCase(fetchExamples.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Process command
    builder
      .addCase(processCommand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(processCommand.fulfilled, (state, action) => {
        state.loading = false;
        state.commands.unshift(action.payload);
      })
      .addCase(processCommand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = voiceSlice.actions;
export default voiceSlice.reducer;
